export function getMerchantImageUrl(imageName, groupId) {
    const isDev = location.hostname === "localhost";
    const host = isDev ? "http://localhost:8082" : "https://content.fhub.pl";
    return `${host}/merchant/image?imgName=${encodeURIComponent(imageName)}&gId=${encodeURIComponent(groupId)}`;
}
export function getUserPreviewUrl(imageName, galleryName, groupId) {
    const isDev = location.hostname === "localhost";
    const host = isDev ? "http://localhost:8082" : "https://content.fhub.pl";
    return `${host}?imgName=${imageName}&gallery=${encodeURIComponent(galleryName)}&gId=${groupId}`;
}
export function getPrivateSessionUrl(groupId, sessionKey) {
    const host = window.location.origin;
    return `${host}/sessions/${encodeURIComponent(groupId)}?k=${encodeURIComponent(sessionKey)}`;
}
